﻿export function toJSONDate(date: Date | string) {

    //ensure JS date:
    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());

}

export function toJSONDateTime(date: Date | string) {

    //ensure JS date:
    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds()) + "";

}


function pad(num: number): string {
    return num < 10 ? "0" + num : num.toString();
}